// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-when[data-v-74046c36]{display:flex;column-gap:.5em}", ""]);
// Exports
module.exports = exports;
